import type { SVGProps } from "react";

export function IconDarkPurpleShoppingCart(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.4375 19.25H13.0625C11.5437 19.25 10.3125 18.0188 10.3125 16.5V16.5C10.3125 14.9812 11.5437 13.75 13.0625 13.75H13.75M9.625 4.125H4.125M9.625 4.125H28.875L24.75 13.75H13.75M9.625 4.125L13.75 13.75M8.25 26.125C8.25 25.3957 8.53973 24.6962 9.05546 24.1805C9.57118 23.6647 10.2707 23.375 11 23.375C11.7293 23.375 12.4288 23.6647 12.9445 24.1805C13.4603 24.6962 13.75 25.3957 13.75 26.125C13.75 26.8543 13.4603 27.5538 12.9445 28.0695C12.4288 28.5853 11.7293 28.875 11 28.875C10.2707 28.875 9.57118 28.5853 9.05546 28.0695C8.53973 27.5538 8.25 26.8543 8.25 26.125ZM23.375 26.125C23.375 25.3957 23.6647 24.6962 24.1805 24.1805C24.6962 23.6647 25.3957 23.375 26.125 23.375C26.8543 23.375 27.5538 23.6647 28.0695 24.1805C28.5853 24.6962 28.875 25.3957 28.875 26.125C28.875 26.8543 28.5853 27.5538 28.0695 28.0695C27.5538 28.5853 26.8543 28.875 26.125 28.875C25.3957 28.875 24.6962 28.5853 24.1805 28.0695C23.6647 27.5538 23.375 26.8543 23.375 26.125Z"
        stroke="#3E2247"
        strokeWidth="2.0625"
        strokeLinecap="square"
      />
    </svg>
  );
}
